import React from 'react';

export const PassMap = ({ seatsData }) => {
  let passengerCount = 1;
  let seatList = [...seatsData.passList];

  if (seatList[0].length === 1) {
    let newFirstRow = seatList[0].concat(seatList[1]);
    seatList = [newFirstRow, ...seatList.slice(2)];
  }

  const passList = seatList.map(row => {
    return [...row].reverse().map(originalSeat => {
      const seat = originalSeat || {
        fullName: 'Empty Seat',
        weight: '',
        unit: ''
      };
      seat.seatNumber = seat.type || passengerCount;
      if (!seat.type) passengerCount++;

      return seat;
    }).reverse()
  });

  return (
    <div className="plane">
      <div className="cockpit"/>
      <div className="fuselage">
        {passList.map((row, index) => (
          <div key={index} className={`row row--${index}`}>
            <div className="seats">
              {row.map((seat, seatIndex) => (
                <div key={seatIndex} className={`${seat.type === 'Pilot' ? 'pilot-seat' : 'seat'}`}>
                  <span className="seat-number" children={seat.seatNumber}/>
                  <span className="name" children={seat.fullName}/>
                  <span className="weight" children={`${seat.weight} ${seat.unit}`}/>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  )};
